import { render } from "./updateOperations.vue?vue&type=template&id=58841ddb&scoped=true"
import script from "./updateOperations.vue?vue&type=script&lang=js"
export * from "./updateOperations.vue?vue&type=script&lang=js"

import "./updateOperations.vue?vue&type=style&index=0&id=58841ddb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58841ddb"]])

export default __exports__